/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetPackageSaleByIdDto } from '../models/custom-result-of-get-package-sale-by-id-dto';
import { CustomResultOfPaginatedListOfGetPackageSalesForUserDto } from '../models/custom-result-of-paginated-list-of-get-package-sales-for-user-dto';
import { CustomResultOfPaginatedListOfGetPackageSalesWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-package-sales-with-pagination-dto';
import { packageSalesCreateGet } from '../fn/package-sales/package-sales-create-get';
import { PackageSalesCreateGet$Params } from '../fn/package-sales/package-sales-create-get';
import { packageSalesCreatePost } from '../fn/package-sales/package-sales-create-post';
import { PackageSalesCreatePost$Params } from '../fn/package-sales/package-sales-create-post';
import { packageSalesDelete } from '../fn/package-sales/package-sales-delete';
import { PackageSalesDelete$Params } from '../fn/package-sales/package-sales-delete';
import { packageSalesGetPackageSalesAudit } from '../fn/package-sales/package-sales-get-package-sales-audit';
import { PackageSalesGetPackageSalesAudit$Params } from '../fn/package-sales/package-sales-get-package-sales-audit';
import { packageSalesGetPackageSalesForUser } from '../fn/package-sales/package-sales-get-package-sales-for-user';
import { PackageSalesGetPackageSalesForUser$Params } from '../fn/package-sales/package-sales-get-package-sales-for-user';
import { packageSalesGetPackageSalesWithPagination } from '../fn/package-sales/package-sales-get-package-sales-with-pagination';
import { PackageSalesGetPackageSalesWithPagination$Params } from '../fn/package-sales/package-sales-get-package-sales-with-pagination';
import { packageSalesUpdateGet } from '../fn/package-sales/package-sales-update-get';
import { PackageSalesUpdateGet$Params } from '../fn/package-sales/package-sales-update-get';
import { packageSalesUpdatePut } from '../fn/package-sales/package-sales-update-put';
import { PackageSalesUpdatePut$Params } from '../fn/package-sales/package-sales-update-put';

@Injectable({ providedIn: 'root' })
export class PackageSalesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `packageSalesCreateGet()` */
  static readonly PackageSalesCreateGetPath = '/PackageSales/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `packageSalesCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  packageSalesCreateGet$Response(params?: PackageSalesCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return packageSalesCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `packageSalesCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  packageSalesCreateGet(params?: PackageSalesCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.packageSalesCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `packageSalesCreatePost()` */
  static readonly PackageSalesCreatePostPath = '/PackageSales/Create';

  /**
   * ثبت بسته ها برای فروش.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `packageSalesCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageSalesCreatePost$Response(params: PackageSalesCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return packageSalesCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * ثبت بسته ها برای فروش.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `packageSalesCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageSalesCreatePost(params: PackageSalesCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.packageSalesCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `packageSalesUpdateGet()` */
  static readonly PackageSalesUpdateGetPath = '/PackageSales/Update';

  /**
   * Get PackageSale By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `packageSalesUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  packageSalesUpdateGet$Response(params?: PackageSalesUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetPackageSaleByIdDto>> {
    return packageSalesUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get PackageSale By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `packageSalesUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  packageSalesUpdateGet(params?: PackageSalesUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetPackageSaleByIdDto> {
    return this.packageSalesUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetPackageSaleByIdDto>): CustomResultOfGetPackageSaleByIdDto => r.body)
    );
  }

  /** Path part for operation `packageSalesUpdatePut()` */
  static readonly PackageSalesUpdatePutPath = '/PackageSales/Update';

  /**
   * به روز رسانی بسته ها برای فروش.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `packageSalesUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageSalesUpdatePut$Response(params: PackageSalesUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return packageSalesUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * به روز رسانی بسته ها برای فروش.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `packageSalesUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageSalesUpdatePut(params: PackageSalesUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.packageSalesUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `packageSalesGetPackageSalesWithPagination()` */
  static readonly PackageSalesGetPackageSalesWithPaginationPath = '/PackageSales/GetPackageSalesWithPagination';

  /**
   * لیست بسته ها با صفحه بندی برای فروش برای مدیریت.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `packageSalesGetPackageSalesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageSalesGetPackageSalesWithPagination$Response(params: PackageSalesGetPackageSalesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetPackageSalesWithPaginationDto>> {
    return packageSalesGetPackageSalesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * لیست بسته ها با صفحه بندی برای فروش برای مدیریت.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `packageSalesGetPackageSalesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageSalesGetPackageSalesWithPagination(params: PackageSalesGetPackageSalesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetPackageSalesWithPaginationDto> {
    return this.packageSalesGetPackageSalesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetPackageSalesWithPaginationDto>): CustomResultOfPaginatedListOfGetPackageSalesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `packageSalesGetPackageSalesForUser()` */
  static readonly PackageSalesGetPackageSalesForUserPath = '/PackageSales/GetPackageSalesForUser';

  /**
   * لیست بسته ها با صفحه بندی برای فروش برای کاربر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `packageSalesGetPackageSalesForUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageSalesGetPackageSalesForUser$Response(params: PackageSalesGetPackageSalesForUser$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetPackageSalesForUserDto>> {
    return packageSalesGetPackageSalesForUser(this.http, this.rootUrl, params, context);
  }

  /**
   * لیست بسته ها با صفحه بندی برای فروش برای کاربر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `packageSalesGetPackageSalesForUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageSalesGetPackageSalesForUser(params: PackageSalesGetPackageSalesForUser$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetPackageSalesForUserDto> {
    return this.packageSalesGetPackageSalesForUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetPackageSalesForUserDto>): CustomResultOfPaginatedListOfGetPackageSalesForUserDto => r.body)
    );
  }

  /** Path part for operation `packageSalesDelete()` */
  static readonly PackageSalesDeletePath = '/PackageSales/{id}';

  /**
   * حذف بسته ها برای فروش.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `packageSalesDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  packageSalesDelete$Response(params: PackageSalesDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return packageSalesDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * حذف بسته ها برای فروش.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `packageSalesDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  packageSalesDelete(params: PackageSalesDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.packageSalesDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `packageSalesGetPackageSalesAudit()` */
  static readonly PackageSalesGetPackageSalesAuditPath = '/PackageSales/GetPackageSalesAudit';

  /**
   * Only for super admin, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `packageSalesGetPackageSalesAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageSalesGetPackageSalesAudit$Response(params: PackageSalesGetPackageSalesAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return packageSalesGetPackageSalesAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `packageSalesGetPackageSalesAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageSalesGetPackageSalesAudit(params: PackageSalesGetPackageSalesAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.packageSalesGetPackageSalesAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

}
